module.exports = __webpack_public_path__ + "img/phone-group.f49ef352.webp";